module.exports = __webpack_public_path__ + "static/media/vlcsnap-2021-06-24-14h05m18s957.e77bf502.png";